<lib-filter-list [configService]="planogramListConfigService"></lib-filter-list>